import Period from '@/orm/models/Account/Period';
import { computed } from '@vue/composition-api';

// TODO: remove mock
const mock = {
  data: [{
    id: 1, quotas: [{ itemType: 'interviews', type: 'temp', value: 20 }, { itemType: 'calls', type: 'permanent', value: 50 }, { itemType: 'sms', type: 'permanent', value: 50 }], price: null, title: 'Promo', description: null, active: false,
  }, {
    id: 2,
    quotas: [{ itemType: 'interviews', type: 'temp', value: 50 }, { itemType: 'calls', type: 'temp', value: 250 }, { itemType: 'sms', type: 'temp', value: 250 }],
    price: {
      id: 6, value: 100, currency: 'USD', currencyName: 'US Dollar',
    },
    title: 'Small business',
    description: null,
    active: false,
  }, {
    id: 3,
    quotas: [{ itemType: 'interviews', type: 'temp', value: 100 }, { itemType: 'calls', type: 'temp', value: 1000 }, { itemType: 'sms', type: 'temp', value: 1000 }],
    price: {
      id: 8, value: 500, currency: 'USD', currencyName: 'US Dollar',
    },
    title: 'Standart',
    description: null,
    active: true,
  }, {
    id: 4,
    quotas: [{ itemType: 'interviews', type: 'temp', value: 250 }, { itemType: 'calls', type: 'temp', value: 2500 }, { itemType: 'sms', type: 'temp', value: 2500 }],
    price: {
      id: 10, value: 1000, currency: 'USD', currencyName: 'US Dollar',
    },
    title: 'Corporation',
    description: null,
    active: false,
  }, {
    id: 5,
    quotas: [{ itemType: 'interviews', type: 'temp', value: 1000 }, { itemType: 'calls', type: 'temp', value: 5000 }, { itemType: 'sms', type: 'temp', value: 5000 }],
    price: {
      id: 12, value: 25000, currency: 'USD', currencyName: 'US Dollar',
    },
    title: 'Mass',
    description: null,
    active: false,
  }],
};

export default function usePeriod() {
  const periods = computed(() => Period.all());
  const maxDiscountPeriod = computed(() => {
    return periods.value.sort((a, b) => {
      if (a.discountPercent > b.discountPercent) {
        return -1;
      }
      if (a.discountPercent < b.discountPercent) {
        return 1;
      }
      return 0;
    })[0];
  });

  async function fetch() {
    try {
      await Period.api().fetchAll();
    } catch (e) {
      await Period.insert(mock);
    }
  }

  return {
    fetch,
    periods,
    maxDiscountPeriod,
  };
}
